import { Box, Link } from '@mui/material';
import {
  FormItemProps,
  Image,
  InputProps,
  Popover,
  TableColumnProps,
} from 'antd';
import moment from 'moment';
import React from 'react';

type CreateCell<T> = (val: T[]) => React.ReactNode;

type GetCreateCell = <T>(fieldName: string) => CreateCell<T>;

const getCreateCell: GetCreateCell = (fieldName: string) => {
  let createCell: CreateCell<any>;
  if (['logo', 'contractFile', 'licenses', 'file'].includes(fieldName)) {
    createCell = (val) => {
      if (val) {
        return (
          <Box
            sx={{
              display: 'flex',
              direction: 'row',
              gap: '5px',
            }}
          >
            {val.map((item, index) => {
              return (
                <Link
                  href={`${location.origin}${item?.response?.[0]?.showPath}`}
                  download={item.name}
                  target="_blank"
                  rel="noreferrer"
                  key={index}
                >
                  {`檔案${index + 1}`}
                </Link>
              );
            })}
          </Box>
        );
      }
      return (createCell = (val) => val);
    };
  } else {
    switch (fieldName) {
      default:
        return (createCell = (val) => val);
      case 'service':
        return (createCell = (val) => {
          if (val) {
            return val.join(', ');
          }
          return (createCell = (val) => val);
        });
      case 'contractPeriod':
        return (createCell = (val) => {
          if (val) {
            const [start, end] = val;
            return `${moment(start).format('YYYY-MM-DD')}~${moment(end).format(
              'YYYY-MM-DD'
            )}`;
          }
          return (createCell = (val) => val);
        });
      case 'createTime':
        return (createCell = (val) => moment(val).format('YYYY-MM-DD'));
      case 'startDate':
        return (createCell = (val) => moment(val).format('YYYY-MM-DD'));
      case 'transferDate':
        return (createCell = (val) => moment(val).format('YYYY-MM-DD'));
      case 'photo':
        return (createCell = (val) => {
          if (val) {
            return (
              <Box
                sx={{
                  display: 'flex',
                  direction: 'row',
                  gap: '5px',
                }}
              >
                {val.map((item, index) => {
                  return (
                    <Popover
                      key={index}
                      content={
                        <Image
                          src={`${location.origin}${item?.response?.[0]?.showPath}`}
                          alt={item.name}
                          height={150}
                        />
                      }
                    >
                      <Link
                        href={`${location.origin}${item?.response?.[0]?.showPath}`}
                        download={item.name}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {`檔案${index + 1}`}
                      </Link>
                    </Popover>
                  );
                })}
              </Box>
            );
          }
          return (createCell = (val) => val);
        });
    }
  }

  return createCell;
};

type FieldGenerator = <T>(
  name: string,
  label: string,
  inputType: string,
  inputProps: InputProps,
  itemProps: FormItemProps,
  columnProps: TableColumnProps<T>
) => {
  name: string;
  label: string;
  input: { type: string; props: typeof inputProps };
  item: { props: typeof itemProps };
  column: { props: typeof columnProps };
};

export const fieldGenerator: FieldGenerator = (
  name = '',
  label = '',
  inputType = 'Input',
  inputProps = {},
  itemProps = {},
  columnProps = {}
) => {
  const field = {
    name,
    label,
    input: { type: inputType, props: inputProps },
    item: {
      props: {
        label,
        name,
        rules: [{ required: true, message: `${label}不能為空` }],
        ...itemProps,
      },
    },
    column: {
      props: {
        title: label,
        dataIndex: name,
        width: 120,
        sortable: true,
        cell: getCreateCell(name),
        ...columnProps,
      },
    },
  };
  return field;
};
